import React, { Component, PropTypes } from "react";

import {
	NitroHeading,
	NitroButton,
	NitroPanel,
	NitroText,
	NitroIcon
} from "nitro-components";

import styled from "styled-components";

const DriverPanel = styled.section`
  margin-bottom: 48px;
//  padding: 40px 40px 0 40px;
`;

const DriverDetail = styled.section`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const DriverAvatar = styled.div`
  position: relative;
  float: left;
  margin-right: 20px;
  border-radius: 100%;
  width: 60px;
  height: 60px;
  background: ${props => props.theme.color.border};
`;
const DriverIcon = styled.i`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const DetailContainer = styled.div`
  flex: 1;
  width: 100%;
`;
const DriverTitleText = styled.div`
  padding-right: 15px;
  color: ${props => props.theme.color.base3};
`;
const InfoIcon = styled.span`
  line-height: 20px;
  float: right;
  padding: 0 12px;
`;

const DriverInformation = styled.section`
    border: 1px solid ${props => props.theme.color[props.variant]};
    text-align: center;
    padding: 12px;
    margin: 10px 0;
`;

const ButtonContainer = styled.section`
    margin: 20px 0 0 0;
`;

const ViewDriverProfile = styled.section`
float: right;
`;

class DriverDetailsPanel extends Component {

  onPanelClick = () => {
    const id = this.props.data.DriverId;
    var route = "/dashboard";
    if (route) {
      this.context.router.push({
        pathname: route,
        state: { id, dashboardType: "driver" }
      });
      return;
    }
  };

	render() {
      const { data } = this.props;

		return (
			<DriverPanel>
				<DriverDetail onClick={this.onPanelClick}>
					<DriverAvatar>
						<DriverIcon>
							<NitroIcon
								name="profile"
								size={24}
								variant="white"
							/>
						</DriverIcon>
					</DriverAvatar>

					<DetailContainer>
						<DriverTitleText>
							<NitroText size={4}> {`Driver`}</NitroText>
						</DriverTitleText>
						<NitroHeading
							noMargin
							label={data.DriverName || ""}
							size="2"
							variant="secondary"
							inline
						/>
						{data.PotentialSuspension &&
							<NitroIcon
								name="suspended"
								size={18}
								variant="negative"
								left={6}
							/>}

					</DetailContainer>

				</DriverDetail>
				{data.PotentialSuspension &&
					<DriverInformation variant="negative">
						<NitroText size={4} bold variant="negative">
							{`This driver may potentially be suspended`}
						</NitroText>
						<ViewDriverProfile>
							<NitroText variant="base3" size="4" bold>
								{`SEE DRIVER`}
							</NitroText>
							<InfoIcon>
								<NitroIcon
									name="arrow-right"
									size={8}
									variant="base3"
								/>
							</InfoIcon>
						</ViewDriverProfile>
					</DriverInformation>}
			</DriverPanel>
		);
	}
}

DriverDetailsPanel.contextTypes = {
  router: PropTypes.object
};

DriverDetailsPanel.propTypes = {
	data: PropTypes.object.isRequired,
    onSelectDriver: PropTypes.func,
    onPanelClick: PropTypes.func,
	  error: PropTypes.bool // TODO .isRequired
};
export default DriverDetailsPanel;



// WEBPACK FOOTER //
// ./src/features/insights/components/driverSafety/components/DriverDetailsPanel.js